import { useMemo, useRef } from "react";

const TAP_SLOP_PX = 10;

/**
 * Distinguish a genuine TAP from the tail end of a drag: browsers fire `click`
 * after pointerup even when the pointer travelled (a pan while zoomed, a
 * swipe), which would toggle the video controls on every gesture. Records the
 * pointer-down position and only treats the click as a tap when the pointer
 * stayed within a small slop radius.
 */
export function useTapHandlers(onTap?: () => void) {
  const start = useRef<{ x: number; y: number } | null>(null);

  return useMemo(
    () => ({
      onPointerDown: (e: React.PointerEvent) => {
        start.current = { x: e.clientX, y: e.clientY };
      },
      // A cancelled pointer sequence (scroll/system gesture takeover) fires no
      // click, so without this the stale origin would be compared against the
      // NEXT click and mis-classify it.
      onPointerCancel: () => {
        start.current = null;
      },
      onClick: (e: React.MouseEvent) => {
        const s = start.current;
        start.current = null;
        if (!onTap) {
          return;
        }
        if (
          s &&
          (Math.abs(e.clientX - s.x) > TAP_SLOP_PX ||
            Math.abs(e.clientY - s.y) > TAP_SLOP_PX)
        ) {
          return;
        }
        onTap();
      },
    }),
    [onTap],
  );
}
